import useLaunchDarkly from '@gaia/hooks/useLaunchDarkly';
import {useUser} from '@gaia/stores/user';
import type {SharedData} from '@gaia/types/SharedData';
import classes from '@map/Map/Map.module.css';

import {FullscreenControl} from './FullscreenControl';
import {GeolocateControl} from './GeolocateControl';
import {LegendControl} from './LegendControl';
import {NavigationControl} from './NavigationControl';
import {ThreeDControls} from './ThreeDControls';

interface MapOrientationControlsProps {
    is3D: boolean;
    map: mapboxgl.Map | undefined;
    setIs3D: SetState<boolean>;
    sharedData: SharedData;
    show3DControl: boolean;
    showFullscreenControl: boolean;
    showGeolocateControl: boolean;
    userLayers: UserLayer[] | undefined;
}

export function MapOrientationControls(props: MapOrientationControlsProps) {
    const {webMapLegend} = useLaunchDarkly(useUser());

    if (window.innerWidth <= 450) return null;

    return (
        <div className={classes.orientation}>
            {webMapLegend && <LegendControl />}

            {props.show3DControl && (
                <ThreeDControls
                    is3D={props.is3D}
                    setIs3D={props.setIs3D}
                    map={props.map}
                    userLayers={props.userLayers}
                />
            )}

            {props.showFullscreenControl && (
                <FullscreenControl
                    sharedData={props.sharedData}
                    userLayers={props.userLayers}
                    map={props.map}
                />
            )}

            {props.showGeolocateControl && <GeolocateControl map={props.map} />}

            <NavigationControl map={props.map} />
        </div>
    );
}
